/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import Ladda from 'ladda';

import Config from '@config/Config';
import Session from '@/Session';

import './DoDWarningPage.css';
import tmplDoDWarningPage from './DoDWarningPage.hbs';

const DoDWarningPage = View.extend({
  template: tmplDoDWarningPage,

  className: 'dod-warning-page',

  ui: {
    continueButton: '.btn-continue'
  },

  templateContext() {
    return {
      bannerText: Config.getBannerText()
    };
  },

  events: {
    'click @ui.continueButton': 'disclaimerAccepted'
  },

  disclaimerAccepted() {
    const spinner = Ladda.create(this.ui.continueButton[0]);
    spinner.start();

    Session.disclaimerAccepted = true;
    if (EXTERNAL) {
      Radio.channel('navigate').request('show:ext:login');
    } else {
      Radio.channel('navigate').request('show:int:login');
    }
  }
});

export default DoDWarningPage;
